import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import estmet from '../data/estaciones-meteorologicas.geojson';
import ClusterSource from 'ol/source/Cluster.js';
import Style from 'ol/style/Style.js';
import Circle from 'ol/style/Circle.js';
import Fill from 'ol/style/Fill.js';
import Stroke from 'ol/style/Stroke.js';
import Text from 'ol/style/Text.js';
//cambio de proyeccion, turf - geojson - OL, para ello hay que importar y // registrar la proyección EPSG:4258 de mi capa estaciones-meteorologicas.geojson

import proj4 from 'proj4';
import { register } from 'ol/proj/proj4.js';

//OpenLayers transforma automáticamente todas las geometrías de EPSG:4258 a EPSG:3857 al cargar los datos.
proj4.defs('EPSG:4258', '+proj=longlat +datum=WGS84 +no_defs');
register(proj4);

// Define alert level colors
const alertColors = {
    'no-alert': 'green',
    'yellow': 'yellow',
    'orange': 'orange',
    'red': 'red'
};

// Function to determine alert level based on wind speed
function getAlertLevel(windSpeed) {
    if (windSpeed >= 90) {
        return 'red';
    } else if (windSpeed >= 60) {
        return 'orange';
    } else if (windSpeed >= 50) {
        return 'yellow';
    } else {
        return 'no-alert';
    }
}

// Function to apply dynamic style to a single station feature
function stationStyle(feature) {
    const windSpeed = feature.get('windSpeed');
    const alertLevel = getAlertLevel(windSpeed);
    const color = alertColors[alertLevel];

    return new Style({
        image: new Circle({
            radius: 8, // Size of the circle icon
            fill: new Fill({ color: color }),
            stroke: new Stroke({ color: 'black', width: 1 })
        })
    });
}

// Function to apply style to a cluster feature
function clusterStyle(feature) {
    const size = feature.get('features').length; // Number of features in the cluster
     // Basic cluster style - you can make this dynamic based on max wind speed in cluster if needed
    return new Style({
        image: new Circle({
            radius: 10 + Math.min(size / 5, 10), // Increase radius slightly with size
            fill: new Fill({ color: 'rgba(0, 0, 255, 0.5)' }), // Semi-transparent blue
            stroke: new Stroke({ color: 'blue', width: 1 })
        }),
        text: new Text({
            text: size.toString(),
            fill: new Fill({ color: '#fff' })
        })
    });
}


// Create a vector source for the station data
const stationsSource = new VectorSource({
    format: new GeoJSON({}),
    url: estmet // Path to your GeoJSON file
});

// Create a cluster source based on the stations source
const clusterSource = new ClusterSource({
    distance: 40, // Distance in pixels to group features
    source: stationsSource
});

// Create a vector layer for the clustered stations, applying a style function
const stationsLayer = new VectorLayer({
    source: clusterSource, // Use the cluster source
    style: function(feature) {
        // Check if the feature is a cluster or a single station
        const originalFeatures = feature.get('features');
        if (originalFeatures && originalFeatures.length > 1) {
            // It's a cluster
            return clusterStyle(feature);
        } else {
            // It's a single station (or a cluster of 1)
            return stationStyle(originalFeatures[0]); // Apply the station style to the original feature
        }
    }
});


// Export the layer and sources
export { stationsLayer, stationsSource, clusterSource, getAlertLevel };